__turbopack_context__.v({
  "teamMemberName": "ifMVia_teamMemberName",
  "teamMemberRole": "ifMVia_teamMemberRole",
});
